import { apiConstants } from './shared/config';
import Vue from 'vue';

export function routes (config) {
    const routes = [{
            path: `/${apiConstants.code}`,
            name: `${apiConstants.code}`,
            redirect: { name: `${apiConstants.code}.home` },
            component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-empty" */ './views/EmptyRouterView.vue'),
            children: [{
                    path: 'home',
                    name: `${apiConstants.code}.home`,
                    component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-home" */ './views/Home.vue'),
                    meta: {
                        title: 'home.title',
                        auth: undefined,
                        hideHeader: false,
                    }
                },
                {
                    path: 'search',
                    name: `${apiConstants.code}.search`,
                    component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-search" */ './views/Search.vue'),
                    props: true,
                    meta: {
                        title: 'Pesquisa',
                        auth: undefined,
                        hideHeader: false,
                    }
                },
                {
                    path: 'framework',
                    name: `${apiConstants.code}.framework`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-framework" */ './views/Framework.vue'),
                    meta: {
                        title: 'framework.title',
                        auth: undefined,
                        hideHeader: false,
                    }
                },
                {
                    path: 'dashboard',
                    name: `${apiConstants.code}.dashboard`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-dashboard" */ './views/Dashboard.vue'),
                    meta: {
                        title: `dashboard.title`,
                        hideHeaderName: true,
                        // auth: {roles: ['ACL_00003'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado'},
                        auth: undefined,
                    }
                },
                {
                    path: 'contact-us',
                    name: `${apiConstants.code}.contact-us`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-contactus" */ './views/Contact.vue'),
                    meta: {
                        title: `contact.title`,
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'profile',
                    name: `${apiConstants.code}.profile`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-profile" */ './views/Profile.vue'),
                    meta: {
                        title: 'profile.title',
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'help',
                    name: `${apiConstants.code}.help`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-help" */ './views/Help.vue'),
                    meta: {
                        title: 'help.title',
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'about',
                    name: `${apiConstants.code}.about`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-about" */ './views/About.vue'),
                    meta: {
                        title: 'about.title',
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'acesso-negado',
                    name: `${apiConstants.code}.forbidden`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-acesso-negado" */ './views/AcessoNegado403.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'pagina-nao-encontrada',
                    name: `${apiConstants.code}.notfound`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-acesso-negado" */ './views/PageNotFound404.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'maintenance',
                    name: `${apiConstants.code}.maintenance`,
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-acesso-negado" */ './views/Page503.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                    }
                },
                {
                    path: 'noticias',
                    name: `${apiConstants.code}.news`,
                    meta: {
                        title: 'Notícias',
                    },
                    redirect: { name: `${apiConstants.code}.news.archive` },
                    component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-empty" */ './views/EmptyRouterView.vue'),
                    children: [
                        {
                            path: '',
                            name: `${apiConstants.code}.news.archive`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-news-archive" */ './views/news/ArchiveNews.vue'),
                            meta: {
                                title: 'Destaques',
                                auth: undefined,
                                hideHeader: false,
                            },
                        },
                        {
                            path: ':slug/:preview?',
                            name: `${apiConstants.code}.news.single`,
                            props: true,
                            component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-news-single" */ './views/news/SingleNews.vue'),
                            meta: {
                                title: 'Notícia',
                                defaultTitle: 'Notícia',
                                auth: undefined,
                                hideHeader: false,
                            },
                        },
                    ],

                },
                {
                    path: 'auth',
                    name: 'authentication',
                    component: () =>
                        import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-empty" */ './views/EmptyRouterView.vue'),
                    children: [{
                            path: 'login/:token?',
                            name: `${apiConstants.code}.login`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-login" */ './views/auth/Login.vue'),
                            meta: {
                                title: 'Bem vindo',
                                auth: false,
                                hideHeader: true,
                            }
                        },
                        {
                            path: 'logout',
                            name: `${apiConstants.code}.logout`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-logout" */ './views/auth/Logout.vue'),
                            meta: {
                                title: 'Logout',
                                auth: true,
                                hideHeader: true,
                            }
                        }, {
                            path: 'register',
                            name: `${apiConstants.code}.register`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-register" */ './views/auth/Register.vue'),
                            meta: {
                                title: 'Criar uma conta',
                                auth: false,
                                hideHeader: true,
                            }
                        },
                        {
                            path: 'resendverificationemail/:email?',
                            name: `${apiConstants.code}.resendverificationemail`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-resendverificationemail" */ './views/auth/ResendVerificationEmail.vue'),
                            meta: {
                                title: 'Reenviar email de verificação',
                                auth: false,
                                hideHeader: true,
                            }
                        }, {
                            path: 'resetpassword',
                            name: `${apiConstants.code}.resetpassword`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-resetpassword" */ './views/auth/ResetPassword.vue'),
                            meta: {
                                title: 'Recuperar password',
                                auth: false,
                                hideHeader: true,
                            }
                        },
                        {
                            path: 'resetpasswordform/:token?/:email?',
                            name: `${apiConstants.code}.resetpasswordform`,
                            component: () =>
                                import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-auth-resetpasswordform" */ './views/auth/ResetPasswordForm.vue'),
                            meta: {
                                title: 'Alterar password',
                                auth: false,
                                hideHeader: true,
                            }
                        }
                    ]
                },
                {
                    path: 'pages/:slug',
                    name: `${apiConstants.code}.pages`,
                    props: true,
                    component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-pages" */ './views/Page.vue'),
                    beforeEnter: async(to, from, next) => {
                        let slug = to.params.slug;

                        try {
                            let resource = await Vue.axios.get(`${apiConstants.codeGeoportalAPI}/front/pages/${slug}`);
                            if (resource.error) {
                                throw resource.error;
                            }
                            let data = resource.data.data;
                            if (data.redirect) {
                                if (!from.name) {
                                    window.location = data.redirect;
                                } else {
                                    window.open(data.redirect, '_blank');
                                }
                            } else {
                                next();
                            }
                        } catch (error) {
                            next({ name: config?.FIRST_COMPONENT?.name });
                        }
                    },
                    meta: {
                        title: 'Página',
                        defaultTitle: 'Página',
                        auth: undefined,
                        hideHeader: false,
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeader: true,
                title: 'Portal',
            }
        },
        {
            path: '/geoserver/home',
            name: 'geoserver.home',
            beforeEnter() { location.href = '/geoserver' }
        },
    ];

    let allow_registration = config?.ALLOW_USER_REGISTRATION == undefined ? true : config?.ALLOW_USER_REGISTRATION;
    if(!allow_registration) {
        let authRoute = routes[0].children.find(r => r.name == 'authentication');
        if(authRoute) {
            authRoute.children = authRoute.children.filter(r => r.name != `${apiConstants.code}.register`);
        }
    }
    return routes;
}

export default routes;
